import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import {
	Comment,
	CreateCommentRequest,
	GetCommentsRequest,
	UpdateCommentRequest,
} from "./types"

export const getComments = (
	apiClient: APIClient,
	params: GetCommentsRequest,
): Promise<Comment[]> =>
	apiClient.get("/comments", { params }).then(response => response.data)

export const getCommentById = (
	apiClient: APIClient,
	id: string,
): Promise<Comment> =>
	apiClient.get(`/comments/${id}`).then(response => response.data)

// GET /comments/{commentId}/attachments/{fileName} — streams a single
// attachment file linked to a comment. The file bytes are returned as an
// ArrayBuffer; the caller supplies the file name/content type (from the
// comment's `attachments`) to trigger the browser download.
export const downloadCommentAttachment = (
	apiClient: APIClient,
	commentId: string,
	fileName: string,
): Promise<ArrayBuffer> =>
	apiClient
		.get(
			`/comments/${commentId}/attachments/${encodeURIComponent(fileName)}`,
			{ responseType: "arraybuffer" },
		)
		.then(response => response.data)

export const createComment = (
	apiClient: APIClient,
	comment: CreateCommentRequest,
): Promise<string> =>
	apiClient
		.post("/comments", {
			relatedEntityId: comment.relatedEntityId,
			content: comment.content,
			type: comment.type,
		})
		.then(response => response.data)

export const updateComment = (
	apiClient: APIClient,
	comment: UpdateCommentRequest,
): Promise<void> => apiClient.put("/comments", comment).then(() => undefined)

export const deleteComment = (
	apiClient: APIClient,
	id: string,
): Promise<void> => apiClient.delete(`/comments/${id}`).then(() => undefined)
